import { Loading } from "@/components/ui/loading";
import { BikeImagesRoute } from "@/modules/bikes/routes/bike-images.route";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/bikes/$bikeId/images")({
	component: BikeImagesRoute,
	pendingComponent: Loading,
});
